import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { UtilsService } from '../../services/utils.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-share-product-modal',
  standalone:true,
  imports:[],
  templateUrl: './share-product-modal.component.html',
  styleUrls: ['./share-product-modal.component.scss']
})
export class ShareProductModalComponent implements OnInit {
  environment: any = environment;
  buttonText: string = "Copy Link";
  imgSrc =`${environment.blobUrl}/assets/images/shareIcons/copy.svg`;
 url: any
  constructor(
    public dialogRef: MatDialogRef<ShareProductModalComponent>,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    if(isPlatformBrowser(this.platformId)) {  
      this.currentUrl = this.sanitizer.bypassSecurityTrustUrl(window.location.href);
    }
  }


  ngOnInit(): void {
    if (this.data && this.data.isBlogShareModel) {
      this.url = `${this.utils.baseUrl}blog/post/${this.utils.createNameForUrl(this.data.blogtitle)}/${this.data.blogId}`
    }
    else {
      let name: any = this.utils.createNameForUrl(this.data.productName)
      this.url = `${this.utils.baseUrl}product/${name}`
    }
  }

  onNoClick(): void {
    this.dialogRef.close()
  }
  copyLink() {
    if(isPlatformBrowser(this.platformId)) {  
    const dummyLink =  window.location.href;
    this.clipboard.copy(dummyLink);
    this.buttonText = "Copied";
    this.imgSrc = `${environment.blobUrl}/assets/images/shareIcons/tick.svg`;
      setTimeout(() => {
        this.buttonText = "Copy Link";
        this.imgSrc = `${environment.blobUrl}/assets/images/shareIcons/copy.svg`;
      }, 2000);
    }
  }
  sharelink():void{
    if(isPlatformBrowser(this.platformId)) {  
      const dummyLink =  window.location.href;
      this.clipboard.copy(dummyLink);
    }
  }
  currentUrl!: SafeUrl;


  // shareViaWhatsApp() {
  //   const currentUrl = window.location.href;
  //   const clickableLink = `${currentUrl}`;
  //   const whatsappMessage = `Check out this link: ${clickableLink}`;
  //   const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;
  //   window.open(whatsappUrl);
  // }
   shareOnWhatsApp() {
    if(isPlatformBrowser(this.platformId)) {  
      var text = "Luminous India\n";
      var currentURL =encodeURIComponent(window.location.href);
      var whatsappLink = "https://web.whatsapp.com/send?text=" + (text + currentURL);
      window.open(whatsappLink, "_blank");
    }
}

shareOnTwitter() {
    if(isPlatformBrowser(this.platformId)) {  
      const url = encodeURIComponent(window.location.href);
      window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank');
    }
}

shareViaEmail() {
  if(isPlatformBrowser(this.platformId)) {  
    const subject = encodeURIComponent('');
    const body = encodeURIComponent(`Luminous India\n ${window.location.href}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }
}

shareOnTelegram() {
  if(isPlatformBrowser(this.platformId)) {  
    const url = encodeURIComponent(window.location.href);
    window.open(`https://t.me/share/url?url=${url}`, '_blank');
  }
}

}
